export default __webpack_public_path__ + "pin_small_selected.svg";